const { validHubspotTrackingId, getCookie } = require("../helper")

exports.addHubspot = ({ hubspotTrackingId }) => {
  return new Promise((resolve, reject) => {
    if (window.gatsbyPluginGDPRCookiesHubspotAdded) return resolve(true)

    const head = document.getElementsByTagName("head")[0]
    const script = document.createElement(`script`)
    script.type = `text/javascript`
    script.async = true
    script.defer = true
    script.id = "hs-script-loader"
    script.onload = () => {
      window.gatsbyPluginGDPRCookiesGoogleAnalyticsAdded = true
      resolve(true)
    }
    script.src = `//js-na3.hs-scripts.com/${hubspotTrackingId}.js`

    setTimeout(() => {
      head.appendChild(script)
    }, 3000)
  })
}

exports.trackHubspotPageview = (options, location) => {
  if (
    getCookie(options.cookieName) === `true` &&
    validHubspotTrackingId(options) &&
    typeof window._hsq != "undefined"
  ) {
    const pagePath = location
      ? location.pathname + location.search + location.hash
      : undefined

    var _hsq = (window._hsq = window._hsq || [])
    _hsq.push(["setPath", pagePath])
    _hsq.push(["trackPageView"])
  }
}
